import './partials/globals';
import './partials/animations';
import './partials/interveningPopup';
import './partials/navigation';
import './partials/translationDropdown';
import './partials/searchDialog';
import './klaro/vendor';